import React, { useRef } from 'react';
import Richtext from '../../global/richtext/Richtext';
import PDPModal from '../pdp-modal/PdpModal';
import AlertMessage from '../../global/alert-message/AlertMessage';
import LinkButton from '../../global/linkButton/linkButton';
import styles from './pdp-content-modal.module.scss';
import useBread from '../../../hooks/useBread';
import { ContentModalData } from '../../../models/pdp-value-tile';

type Props = {
  closeModal: () => void;
  data: ContentModalData;
  isOpen: boolean;
  fullscreen?: boolean;
  bikePrice?: number;
};

const PDPContentModal = ({
  closeModal,
  data,
  isOpen,
  fullscreen = true,
  bikePrice
}: Props) => {
  const breadWrapperRef = useRef(null);
  const { breadError, hideError } = useBread(breadWrapperRef, bikePrice);
  const { text, cta } = data;

  const onClickBreadCTA = () => {
    window.location.hash = cta?.route || '';
    closeModal();
  };

  return (
    <PDPModal
      isModalOpen={isOpen}
      onCloseModal={closeModal}
      className={styles['pdp-content-modal__container']}
      fullscreen={fullscreen}
    >
      <div className={styles['pdp-content-modal__content-container']}>
        <Richtext
          customClasses={{
            container: styles['pdp-content-modal__richtext-container'],
            header: styles['pdp-content-modal__title'],
            header2: styles['pdp-content-modal__subtitle'],
            paragraph: styles['pdp-content-modal__paragraph'],
            hr: styles['pdp-content-modal__hr']
          }}
          data={text}
        />
        {cta && (
          <div
            className={styles['pdp-content-modal__cta-container']}
            ref={breadWrapperRef}
          >
            <LinkButton
              data={cta}
              linkClass={styles['pdp-content-modal__cta-link']}
              onClick={onClickBreadCTA}
            />
            {breadError && (
              <div className={styles['pdp-content-modal__bread-error']}>
                <AlertMessage onClose={hideError} arrow="topmid" />
              </div>
            )}
          </div>
        )}
      </div>
    </PDPModal>
  );
};

export default PDPContentModal;
